import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleRight, faHeart } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import Modal from "react-bootstrap/Modal";
import { api } from "../../Constant"; // ✅ Make sure this is correct
import newarrival from "../../assets/images/new-arrivals-img-1.png";

const OrderDetail = () => {
  const { order_id } = useParams();
  const [order, setOrder] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      const userId = localStorage.getItem("userId");
      const guestId = localStorage.getItem("guest_id");
      const isGuest = userId === guestId;

      const payload = {
        order_id: order_id,
        ...(isGuest ? { guest_id: guestId } : { user_id: userId }),
      };

      try {
        const response = await axios.post(api + "order_details", payload);
        if (response.data.success) {
          setOrder(response.data.data);
        }
      } catch (err) {
        console.error("Failed to load order detail", err);
      }
    };

    fetchOrderDetails();
  }, [order_id]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1320, settings: { slidesToShow: 4 } },
      { breakpoint: 1199, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  };

  if (!order) return <p className="text-center">Loading Order Details...</p>;

  return (
    <div className="track-order-bg pt-80 pb-80">
      <div className="container">
        {/* Breadcrumb */}
        <div className="row">
          <div className="col-lg-12">
            <div className="track-order-flex">
              <Link to="/orders"><h6 className="first-child">ORDER</h6></Link>
              <FontAwesomeIcon icon={faAngleDoubleRight} />
              <h6 className="second-child">ORDER DETAILS</h6>
            </div>
          </div>
        </div>

        {/* Order Info */}
        <div className="row track-order-idcont-main">
          {/* <div className="col-lg-5 track-order-idcont">
            <p><b>Order Id</b> - {order.order_id}</p>
          </div> */}
          <div className="col-lg-5 track-order-idcont">
            <p><b>Order Placed</b> - {order.created_date}</p>
          </div>

          <div className="col-lg-5 track-order-idcont">
            <h5>Shipping Address</h5>
            <p className="address">{order.shipping_address?.first_name}</p>
            <p className="address">{order.shipping_address?.address}</p>
            <p className="address">{order.shipping_address?.phone_number}</p>
          </div>

          {/* <div className="col-lg-5 track-order-idcont">
            <h5>Billing Address</h5>
            <p className="address">{order.billing_address?.name}</p>
            <p className="address">{order.billing_address?.address}</p>
            <p className="address">{order.billing_address?.phone}</p>
          </div> */}
        </div>

        {/* Product List */}
        <div className="row order-image-listmain pt-40 pb-40">
          <div className="col-lg-9 order-image-list-bg">
            <table className="track-list-table product-table table-responsive">
              <tbody>
                {order.description.map((item, index) => (
                  <tr key={index}>
                    <td><img src={item.product_image} alt={item.product_name}  style={{ width: "100%" }}  /></td>
                    <td><h6>{item.product_name}</h6><p>{item.product_size}</p></td>
                    <td className="cont">Qty - {item.product_quantity}</td>
                    <td className="cont">  Price - ₹ {item.product_amount}</td>
                    <td className="cont"> Total - ₹ {item.product_total}</td>
                    {/* <td className="cont">
                      <button className="track-cancel-btn" onClick={handleShow}>
                        Cancel Order
                      </button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Order Summary */}
        <div className="row pt-40 pb-40 track-total">
          <div className="col-lg-9">
            <div className="row">
              <div className="col-lg-12 payment-title"><h5>Order Summary</h5></div>
              {/* <div className="col-lg-6 left-payment-detail"><p>Payment Method</p></div>
              <div className="col-lg-6 right-payment-detail"><p>{order.payment_method}</p></div> */}

              {/* <div className="col-lg-6 left-payment-detail"><p>Sub Total</p></div>
              <div className="col-lg-6 right-payment-detail"><p className="total-payment"><b>₹ {order.sub_total}</b></p></div> */}

              <div className="col-lg-6 left-payment-detail"><p>Shipping Charge</p></div>
              <div className="col-lg-6 right-payment-detail"><p>{order.shipping_charge || 'Free'}</p></div>

                 <div className="col-lg-6 left-payment-detail"><p className="coupon-cont">Coupon Code</p></div>
              <div className="col-lg-6 right-payment-detail">
  <p className="coupon-cont">
    {order.coupon_code ? order.coupon_code : "No coupon applied"}
  </p>
</div>


              <div className="col-lg-6 left-payment-detail"><p className="coupon-cont">Coupon</p></div>
              <div className="col-lg-6 right-payment-detail"><p className="coupon-cont">₹ {order.coupon_discount || 0}</p></div>

              <hr className="payment-border" />
              <div className="col-lg-6 left-payment-detail"><p>Total</p></div>
              <div className="col-lg-6 right-payment-detail"><p className="last-payment-sdetail"><b>₹ {order.total}</b></p></div>
            </div>
          </div>
        </div>

        {/* Related Products (Static) */}
        {/* <div className="row track-related-bgmain">
          <div className="col-lg-9 title"><h5>Products You May Like</h5></div>
          <div className="col-lg-9 track-related-bg">
            <Slider {...sliderSettings}>
              {[1, 2, 3, 4].map((_, index) => (
                <div key={index} className="grid_col">
                  <div className="inner-box">
                    <div className="img-box"><img src={newarrival} alt="img" /></div>
                    <div className="wishlist_box" style={{ cursor: "pointer" }}>
                      <FontAwesomeIcon icon={faHeart} />
                    </div>
                    <div className="content-box">
                      <p>Sample Product</p>
                      <div className="cn-inner-box" style={{ display: "flex", justifyContent: "space-between" }}>
                        <h6>
                          ₹ 200 <span style={{ textDecoration: "line-through", marginLeft: "10px", color: "gray", fontSize: "14px" }}>₹ 200</span>
                        </h6>
                        <button className="btn_1">Shop now</button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div> */}
      </div>

      {/* Cancel Modal */}
      {/* <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="row inside-pading-pop">
            <div className="col-lg-12">
              <h6>Why do you want to cancel your order?</h6>
            </div>
            {[
              "Ordered wrong item",
              "Need to change shipping address",
              "Need to change payment method",
              "Item price too high",
              "Others"
            ].map((reason, idx) => (
              <div key={idx} className="col-lg-12 input-box">
                <input type="radio" name="cancelReason" />
                <label>{reason}</label>
              </div>
            ))}
            <div className="col-lg-12 input-box">
              <textarea placeholder="Type Your Reason..."></textarea>
            </div>
            <div className="col-lg-12 input-box-btn">
              <button>Cancel Your Order</button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default OrderDetail;
